import React from "react";
import Principal from "@app/model/authentication/Principal";
import FormButton from "@app/component/form/button/FormButton";
import {ChevronRightIcon} from "@heroicons/react/20/solid";
import SetupSubscriptionPlanFragment from "@app/site/registration/fragment/SetupSubscriptionPlanFragment";
import {useMutation} from "@tanstack/react-query";
import RegistrationService from "@app/model/registration/service/RegistrationService";


const SelectSubscriptionPlanFlowPage: React.FunctionComponent<{
    onComplete: (principal: Principal) => any
}> = ({onComplete}) => {

    const selectSubscriptionPlanMutation = useMutation({
        mutationFn: RegistrationService.selectSubscriptionPlan,
        onSuccess: (data) => onComplete(data)
    })
    const onFinish = () => {
        selectSubscriptionPlanMutation.mutate()
    }

    return <div className="min-h-full bg-white">
        <div className="flex lg:h-dvh min-w-max content-center justify-center flex-1">
            <div className="flex min-h-full flex-1 flex-col justify-center px-6 py-12 lg:px-8">
                <div className="sm:mx-auto sm:w-full sm:max-w-2xl">
                    <div>
                        <img
                            className="h-10 w-auto"
                            src="/assets/img/brand/logo-icon.png"
                            alt="RoomPulse"
                        />
                        <div className="flex flex-wrap items-center justify-between sm:flex-nowrap mt-8">
                            <div>
                                <h2 className="text-2xl font-bold leading-9 tracking-tight text-gray-900">
                                    Select Your Plan
                                </h2>
                            </div>
                            <div className="sm:ml-4 flex-shrink-0 space-x-2">
                                <FormButton state="primary" onClick={onFinish}>
                                    <span>Finish</span>
                                    <ChevronRightIcon className="h-5 w-5" aria-hidden="true"/>
                                </FormButton>
                            </div>
                        </div>
                        <SetupSubscriptionPlanFragment/>
                    </div>
                </div>
            </div>
        </div>
    </div>

};
export default SelectSubscriptionPlanFlowPage;